// GLSL ES 3.00 sources.
const H = '#version 300 es\nprecision highp float;precision highp int;\n';

export const POINT_VS = H + `
layout(location=0) in vec3 aPos;
layout(location=1) in vec4 aCol;
layout(location=2) in vec2 aOct;
// single-scan edit state (edit cloud only; 0 elsewhere): bit 0 deleted, 1 selected,
// 2 candidate, 5 in an object, 6 in a split part, 7 hidden (layer off), 8-15 that id,
// 16-22 class (an index into uClsT: 1 floor, 2 solid, 3 movable, 4.. user classes),
// 24-31 part label (an index into uLabT; the object page's overlay)
layout(location=3) in uint aEdit;
uniform highp sampler2D uClsT;   // 128 x 1: each class's tint
uniform highp sampler2D uLabT;   // 256 x 1: each part label's tint
// edit cloud only: the vertex's frame (index into uFrameT, whose row k is E(frame k) as 3 texels (R row | t))
layout(location=4) in uint aFrame;
uniform highp sampler2D uFrameT;
uniform int uFrameOn;
// the record's quality bytes (0 unknown; both 0 for a version 1 build): x capture range (* uRangeMax.x m),
// y image edge (prep/edges.py: bit 0 known, bit 1 Canny edge, bits 2-7 Sobel magnitude)
layout(location=5) in vec2 aQual;
// point density: how many points are within Settings.densR of it (edit clouds, once measured; 0 unknown)
layout(location=6) in float aDens;
uniform vec2 uDens;   // log of the densities at the blue and red ends of the ramp
// image features (edit clouds, once found; photo/featshade.ts): bit 0 known, 1 photo corner, 2 photo line, 3 depth jump, 4 depth crease
layout(location=7) in uint aFeat;
// the data group shown (Data shading, edit clouds): each point's value, below -1e38 when not in it
layout(location=8) in float aVal;
uniform vec2 uVal;   // the values at the blue and red ends of the ramp
uniform vec2 uValCut; uniform int uValCutOn;   // data group: only the points with values from x to y drawn (when on)
uniform int uEditShow;   // bit 0 deleted points, 1 classes, 2 objects/parts, 3 part labels
uniform mat4 uVP, uV, uModel;
uniform vec3 uOrigin, uSize, uEye, uFwd, uSolid;
uniform float uSpacing, uPx, uOrtho, uSizeMul, uGain, uCullT;
uniform vec2 uRamp, uRangeMax;
uniform int uMode, uSelOnly, uCull, uPeriod, uEdgeView, uFeatView;
// volumes: 3 affine rows each, world -> [-1,1]^3; kind 0 hide, 1 align, 2 solid
uniform vec4 uVol[96];
uniform int uVolKind[32];
uniform int uVolN, uVolMask, uVolShow;
uniform float uVolTint;
out vec3 vCol;
out float vDepth;
vec3 oct(vec2 e){
vec3 n=vec3(e,1.-abs(e.x)-abs(e.y));
float t=max(-n.z,0.);
n.xy+=vec2(n.x>=0.?-t:t,n.y>=0.?-t:t);
return normalize(n);
}
vec3 ramp(float t){
vec3 a=vec3(.19,.07,.23),b=vec3(.11,.53,.94),c=vec3(.3,.94,.47),d=vec3(.98,.73,.15),e=vec3(.73,.08,.03);
t=clamp(t,0.,1.)*4.;
return t<1.?mix(a,b,t):t<2.?mix(b,c,t-1.):t<3.?mix(c,d,t-2.):mix(d,e,t-3.);
}
vec3 hue(float h){return clamp(abs(mod(h*6.+vec3(0.,4.,2.),6.)-3.)-1.,0.,1.);}
void main(){
vec3 lp=uOrigin+aPos*uSize, ln=oct(aOct*2.-1.);
if(uFrameOn==1){
int k=int(aFrame);
vec4 r0=texelFetch(uFrameT,ivec2(0,k),0),r1=texelFetch(uFrameT,ivec2(1,k),0),r2=texelFetch(uFrameT,ivec2(2,k),0);
lp=vec3(dot(r0.xyz,lp)+r0.w,dot(r1.xyz,lp)+r1.w,dot(r2.xyz,lp)+r2.w);
ln=vec3(dot(r0.xyz,ln),dot(r1.xyz,ln),dot(r2.xyz,ln));
}
vec3 p=(uModel*vec4(lp,1.)).xyz;
int fl=int(aCol.a*255.+.5);
bool hasN=(fl&1)==1;
vec3 n=mat3(uModel)*ln;
// backface cull: drop points whose normal (oriented to the capturing camera) faces away from the view,
// or turns from it by more than the threshold (cos of the angle below uCullT)
bool cut=(uCull==1&&hasN&&dot(normalize(n),uOrtho>.5?-uFwd:normalize(uEye-p))<uCullT);
int hit=0;
vec4 q=vec4(p,1.);
for(int i=0;i<32;i++){
if(i>=uVolN)break;
if(((uVolMask>>i)&1)==0)continue;
vec3 l=vec3(dot(uVol[3*i],q),dot(uVol[3*i+1],q),dot(uVol[3*i+2],q));
if(all(lessThanEqual(abs(l),vec3(1.))))hit|=1<<uVolKind[i];
}
bool hid=(hit&1)!=0&&(hit&4)==0;
bool del=((aEdit&1u)!=0u&&(uEditShow&1)==0)||(aEdit&128u)!=0u;
// selection only: just the selected points, in the mode's colours; those otherwise hidden show in blue
bool so=uSelOnly==1,gone=del||(hid&&uVolShow==0);
if(cut||(so?(aEdit&2u)==0u:gone)||(uMode==11&&uValCutOn==1&&(aVal<uValCut.x||aVal>uValCut.y))){gl_Position=vec4(2.,2.,2.,1.);gl_PointSize=1.;return;}
vec4 v=uV*vec4(p,1.);
vDepth=-v.z;
gl_Position=uVP*vec4(p,1.);
gl_PointSize=clamp(uSpacing*uPx*uSizeMul/(uOrtho>.5?1.:max(-v.z,.01)),1.,64.);
vec3 c=aCol.rgb*uGain;
if(uMode==1){
vec3 l=uOrtho>.5?-uFwd:normalize(uEye-p);
c=vec3(hasN?.12+.88*abs(dot(n,l)):.6);
}else if(uMode==2)c=ramp((p.z-uRamp.x)/(uRamp.y-uRamp.x));
else if(uMode==3)c=uSolid*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
else if(uMode==4)c=hasN?n*.5+.5:vec3(.5);
else if(uMode==5){
// source frame (flags bits 2-7 = frame % 64, bit 1 = known): hue cycles every uPeriod frames
vec3 h=(fl&2)!=0?hue(float((fl>>2)%uPeriod)/float(uPeriod)):vec3(.45);
c=h*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
}else if(uMode==6){
// capture range: how far the scan's camera was, 0 to uRangeMax.y m on the height ramp; unknown grey
vec3 h=aQual.x>.5?ramp(aQual.x*uRangeMax.x/uRangeMax.y):vec3(.45);
c=h*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
}else if(uMode==7){
// depth edges, from the depth image each point came from: Sobel strength white on dark lit grey,
// Canny edges yellow on the dimmed scan colours, or the signed strength (foreground orange,
// background blue; a build without the side shows all orange); unknown grey
int e=int(aQual.y+.5);
float lit=hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.;
if((e&1)==0)c=vec3(.45)*lit;
else if(uEdgeView==0)c=mix(vec3(.13)*lit,vec3(1.),float(e>>3)/31.);
else if(uEdgeView==2)c=mix(vec3(.13)*lit,(e&4)!=0?vec3(.2,.55,1.):vec3(1.,.55,.15),float(e>>3)/31.);
else c=(e&2)!=0?vec3(1.,.85,.2):vec3(dot(aCol.rgb,vec3(.3,.59,.11)))*.4;
}else if(uMode==8){
// point density: sparse blue to dense red on the height ramp (log scale), lit; unknown grey
vec3 h=aDens>.5?ramp((log(aDens)-uDens.x)/(uDens.y-uDens.x)):vec3(.45);
c=h*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
}else if(uMode==11){
// data group: its values blue to red on the height ramp (clamped at the ends), lit; points not in it dark grey
vec3 h=aVal>-1e38?ramp((aVal-uVal.x)/max(uVal.y-uVal.x,1e-30)):vec3(.3);
c=h*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
}else if(uMode==9){
// image features, from the photo of the frame each point came from, on the dimmed scan colours: uFeatView 0 all
// (depth jumps cyan, creases blue, photo lines red, corners green), 1 the photo's corners and lines, 2 the depth's
// jumps and creases, 3 photo against depth (on both yellow, depth only cyan, photo only red); unknown grey
uint e=aFeat;
bool cn=(e&2u)!=0u,li=(e&4u)!=0u,dp=(e&24u)!=0u;
vec3 jc=(e&8u)!=0u?vec3(0.,.9,1.):vec3(.24,.43,1.),cr=vec3(.19,.82,.35),lr=vec3(1.,.23,.19);
if((e&1u)==0u)c=vec3(.45)*(hasN?.45+.55*abs(dot(n,uOrtho>.5?-uFwd:normalize(uEye-p))):1.);
else{
c=vec3(dot(aCol.rgb,vec3(.3,.59,.11)))*.35;
if(uFeatView==0){if(dp)c=jc;if(li)c=lr;if(cn)c=cr;}
else if(uFeatView==1){if(li)c=lr;if(cn)c=cr;}
else if(uFeatView==2){if(dp)c=jc;}
else if(dp&&li)c=vec3(1.,.84,.04);else if(dp)c=jc;else if(li)c=lr;
}
}
if(so){vCol=gone?vec3(.15,.75,1.):c;return;}
if(hid)c=mix(c,vec3(1.,.3,.25),.6);
else if((hit&4)!=0)c=mix(c,vec3(1.,.72,.1),uVolTint);
else if((hit&2)!=0)c=mix(c,vec3(.2,.85,1.),uVolTint);
if(aEdit!=0u){
float id=float(aEdit>>8);
if((uEditShow&4)!=0&&(aEdit&32u)!=0u)c=mix(c,hue(fract(id*.618)),.6);
else if((uEditShow&4)!=0&&(aEdit&64u)!=0u)c=mix(c,hue(fract(id*.618+.31)),.35);
uint k=(aEdit&32u)!=0u?0u:(aEdit>>16)&127u;   // an object's points show as the object
if((uEditShow&2)!=0&&k!=0u)c=mix(c,texelFetch(uClsT,ivec2(int(k),0),0).rgb,.45);
uint lb=aEdit>>24;
if((uEditShow&8)!=0&&lb!=0u)c=mix(c,texelFetch(uLabT,ivec2(int(lb),0),0).rgb,.6);
if((aEdit&1u)!=0u)c=mix(c,vec3(.75,.1,.1),.75);
if((aEdit&2u)!=0u)c=mix(c,vec3(1.,.15,1.),.65);
if((aEdit&4u)!=0u)c=mix(c,vec3(1.,1.,.15),.65);
}
vCol=c;
}`;

export const POINT_FS = H + `
in vec3 vCol;
in float vDepth;
layout(location=0) out vec4 o;
void main(){
vec2 c=gl_PointCoord*2.-1.;
if(dot(c,c)>1.)discard;
o=vec4(vCol,1.);
}`;

// Pick pass: attachment 0 = the view depth's float bits, attachment 1 = id.
export const PICK_FS = H + `
in vec3 vCol;
in float vDepth;
uniform uint uId;
layout(location=0) out vec4 o0;
layout(location=1) out vec4 o1;
vec4 b(uint u){return vec4(float(u&255u),float((u>>8)&255u),float((u>>16)&255u),float(u>>24))/255.;}
void main(){
vec2 c=gl_PointCoord*2.-1.;
if(dot(c,c)>1.)discard;
o0=b(floatBitsToUint(vDepth));
o1=b(uId);
}`;

export const QUAD_VS = H + `
out vec2 vUv;
void main(){
vec2 p=vec2(float((gl_VertexID<<1)&2),float(gl_VertexID&2));
vUv=p;
gl_Position=vec4(p*2.-1.,0.,1.);
}`;

// Eye-dome lighting + composite. Writes the scene depth so lines can depth-test.
export const EDL_FS = H + `
in vec2 vUv;
uniform sampler2D uCol, uDepth;
uniform vec2 uTexel, uNF;
uniform float uRadius, uStrength, uOrtho, uEdl, uFill;
uniform vec3 uBg;
out vec4 o;
float lz(float d){
return log2(uOrtho>.5?uNF.x+d*(uNF.y-uNF.x):2.*uNF.x*uNF.y/((uNF.y+uNF.x)-(2.*d-1.)*(uNF.y-uNF.x)));
}
float ld(vec2 uv){
float d=texture(uDepth,uv).r;
return d>=1.?-1e9:lz(d);
}
void main(){
float d=texture(uDepth,vUv).r;
vec3 c=texture(uCol,vUv).rgb;
// gap fill: an empty pixel with points on >=3 of 4 opposite direction pairs
// takes the nearest point's colour and depth (so no growth at silhouettes)
if(d>=1.&&uFill>0.){
ivec2 sz=textureSize(uDepth,0),p=ivec2(vUv*vec2(sz));
ivec2 dirs[8]=ivec2[8](ivec2(1,0),ivec2(1,1),ivec2(0,1),ivec2(-1,1),ivec2(-1,0),ivec2(-1,-1),ivec2(0,-1),ivec2(1,-1));
bool hit[8];
float best=1.;ivec2 bp=p;
for(int i=0;i<8;i++){
hit[i]=false;
for(int t=1;t<=2;t++){
ivec2 q=clamp(p+dirs[i]*int(max(1.,floor(uFill*float(t)*.5))),ivec2(0),sz-1);
float s=texelFetch(uDepth,q,0).r;
if(s<1.){hit[i]=true;if(s<best){best=s;bp=q;}break;}
}
}
int n=0;
for(int i=0;i<4;i++)if(hit[i]&&hit[i+4])n++;
if(n>=3){d=best;c=texelFetch(uCol,bp,0).rgb;}
}
if(d>=1.){o=vec4(uBg,1.);gl_FragDepth=1.;return;}
if(uEdl>.5){
float z=lz(d),r=0.;
for(int i=0;i<8;i++){
float a=float(i)*.785398;
float n=ld(vUv+vec2(cos(a),sin(a))*uTexel*uRadius);
if(n>-1e8)r+=max(0.,z-n);
}
c*=exp(-r/8.*300.*uStrength);
}
o=vec4(c,1.);
gl_FragDepth=d;
}`;

// aCol: a colour per vertex, or (its array off) one for the whole line set
export const LINE_VS = H + `
layout(location=0) in vec3 aPos;
layout(location=1) in vec4 aCol;
uniform mat4 uVP;
out vec4 vCol;
void main(){gl_Position=uVP*vec4(aPos,1.);vCol=aCol;}`;

export const LINE_FS = H + `
in vec4 vCol;
out vec4 o;
void main(){o=vCol;}`;

// A camera image pushed out to its depth map: a mesh over the depth grid (vertex = depth pixel, by
// gl_VertexID), each vertex back-projected with the depth camera's intrinsics uK (fx, fy, cx, cy) and
// placed by uM (camera to world). A vertex with no depth, or on a depth edge (a neighbour more than 5 %
// nearer or further), drops every triangle it is in. Each vertex is pulled towards the viewer (3 cm + 1 % of
// its distance), so the photo shows over its own frame's point splats (which stand proud of the surface)
// and still goes behind anything really in front of it. With uHasW, vW: the weight at the vertex (uW.r, a grid
// over the depth image like uZ: Image weights shading), else 1; vSel: how selected its points are (uW.g). Then a
// vertex of weight 0 drops its triangles too, and with uSelOnly so does one with none of its points selected.
// Far away the grid is coarser (Viewer.imageDraws): every uStep-th depth pixel (uGrid of them across and down, the
// last row and column kept), the depth-edge test against the neighbours uStep away (and so uStep times as tolerant).
export const IMG_VS = H + `
uniform highp sampler2D uZ, uW;
uniform int uHasW, uSelOnly, uStep;
uniform ivec2 uSz, uGrid;
uniform vec4 uK;
uniform mat4 uVP, uM;
uniform vec3 uEye, uFwd;
uniform float uOrtho;
out vec2 vUv;
out float vOk, vW, vSel;
void main(){
ivec2 p=min(ivec2(gl_VertexID%uGrid.x,gl_VertexID/uGrid.x)*uStep,uSz-1);
vec2 ws=uHasW==1?texelFetch(uW,p,0).rg:vec2(1.,0.);
vW=ws.r;vSel=ws.g;
float z=texelFetch(uZ,p,0).r,ok=z>0.?1.:0.;
ivec2 dirs[4]=ivec2[4](ivec2(1,0),ivec2(-1,0),ivec2(0,1),ivec2(0,-1));
for(int i=0;i<4;i++){
float n=texelFetch(uZ,clamp(p+dirs[i]*uStep,ivec2(0),uSz-1),0).r;
if(n>0.&&abs(n-z)>.05*float(uStep)*z)ok=0.;
}
if(uHasW==1&&(vW<=0.||(uSelOnly==1&&vSel<.5)))ok=0.;
if(z<=0.)z=1.;
vec3 c=vec3((float(p.x)-uK.z)/uK.x*z,(float(p.y)-uK.w)/uK.y*z,z);
vec3 w=(uM*vec4(c,1.)).xyz,d=uOrtho>.5?-uFwd:uEye-w;
float L=length(d);
if(L>1e-6)w+=d/L*min(.03+.01*(uOrtho>.5?z:L),.5*L);
gl_Position=uVP*vec4(w,1.);
vUv=(vec2(p)+.5)/vec2(uSz);
vOk=ok;
}`;

// uGain: the photo's exposure gain (Match exposure; else 1)
export const IMG_FS = H + `
uniform sampler2D uImg;
uniform vec3 uGain;
in vec2 vUv;
in float vOk;
out vec4 o;
void main(){if(vOk<.999)discard;o=vec4(min(texture(uImg,vUv).rgb*uGain,1.),1.);}`;

// Image weights shading (Viewer.drawWeighted): every frame's photo, each pixel the weighted mean of the photos
// there (weight: its points' weights, IMG_VS vW). First the nearest surface with any weight (depth only:
// IMGW_DEPTH_FS), then each photo within a few cm of it adds (rgb * w, w) (IMGW_ACC_FS, blended ONE, ONE into a
// float target), then IMGW_COMP_FS divides (the points aren't drawn), carrying the depth for the lines.
export const IMGW_DEPTH_FS = H + `
in vec2 vUv;
in float vOk, vW, vSel;
out vec4 o;
void main(){if(vOk<.999||vW<=0.)discard;o=vec4(0.);}`;

// linear depth; the photo's exposure gain (uGain) and the selection's tint (as the points have it), off in selection only (only it is drawn)
const LIN = `
uniform vec2 uNF;
uniform float uOrtho;
uniform int uSelOnly;
uniform vec3 uGain;
in float vSel;
float lin(float d){return uOrtho>.5?uNF.x+d*(uNF.y-uNF.x):2.*uNF.x*uNF.y/((uNF.y+uNF.x)-(2.*d-1.)*(uNF.y-uNF.x));}
vec3 tint(vec3 c){c=min(c*uGain,1.);return uSelOnly==1?c:mix(c,vec3(1.,.15,1.),.65*clamp(vSel,0.,1.));}`;

export const IMGW_ACC_FS = H + LIN + `
uniform sampler2D uImg;
uniform highp sampler2D uFront;
in vec2 vUv;
in float vOk, vW;
out vec4 o;
void main(){
if(vOk<.999||vW<=0.)discard;
float f=texelFetch(uFront,ivec2(gl_FragCoord.xy),0).r;
if(f>=1.)discard;
float a=lin(f),b=lin(gl_FragCoord.z);
if(b>a+.02+.01*a)discard;
o=vec4(tint(texture(uImg,vUv).rgb)*vW,vW);
}`;

// uAcc: (sum rgb * w, sum w), or the fallback's premultiplied alpha-over (no float target); uFront: their depth.
export const IMGW_COMP_FS = H + `
in vec2 vUv;
uniform sampler2D uAcc;
uniform highp sampler2D uFront;
out vec4 o;
void main(){
vec4 a=texture(uAcc,vUv);
float d=texture(uFront,vUv).r;
if(a.a<=1e-4||d>=1.)discard;
o=vec4(a.rgb/a.a,1.);
gl_FragDepth=d;
}`;

// The fallback's accumulate: each photo over the last, alpha its weight (to 1), depth tested against the front.
export const IMGW_OVER_FS = H + LIN + `
uniform sampler2D uImg;
uniform highp sampler2D uFront;
in vec2 vUv;
in float vOk, vW;
out vec4 o;
void main(){
if(vOk<.999||vW<=0.)discard;
float f=texelFetch(uFront,ivec2(gl_FragCoord.xy),0).r;
if(f>=1.)discard;
float a=lin(f),b=lin(gl_FragCoord.z);
if(b>a+.02+.01*a)discard;
float w=min(vW,1.);
o=vec4(tint(texture(uImg,vUv).rgb)*w,w);
}`;
